import React from 'react';
import { useToggleState } from '@toss/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ChevronDownIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
import { cn } from '@/utils';
import { isSidebarMenuActive, type SidebarMenu } from './Sidebar';

/**
 *  모바일에서만 사용되는 드롭다운 메뉴
 *  모바일이 아닌경우 타이틀만 나오게 설계 되어 있습니다
 * */
export const SidebarMobileDropdownMenu = (props: Omit<SidebarDropdownMenuProps, 'footerMenus'>) => {
  const {
    title,
    menus,
    className,
    hideMobileDropdown = false
  } = props;
  const [isOpen, toggleOpen] = useToggleState(false);
  return <div className={cn('flex flex-col w-full gap-sm', className)} data-sentry-component="SidebarMobileDropdownMenu" data-sentry-source-file="SidebarMobileDropdownMenu.tsx">
      <div className={'flex items-center gap-xs'}>
        {title}
        {!hideMobileDropdown && <IconButton intent={'neutral'} className={cn('flex tablet-sm:hidden', isOpen ? 'bg-gray-300 hover:bg-gray-300' : 'bg-gray-200')} size={'sm'} onClick={toggleOpen}>
            <ChevronDownIcon size={'lg'} className={isOpen ? 'rotate-180' : ''} />
          </IconButton>}
      </div>
      {!hideMobileDropdown && isOpen && <div className={cn('tablet-sm:hidden', 'bg-neutral px-md py-md rounded-md border border-alternative', 'flex flex-col items-stretch gap-sm')}>
          {/* 모바일에서는 다 붙여서 보여준다 */}
          {[...menus].map((menu, index, all) => <React.Fragment key={menu.label}>
              <Menu {...menu} />
              {all.length !== index + 1 && <div className={'h-[1px] w-full bg-alternative'} key={menu.label + index} />}
            </React.Fragment>)}
        </div>}
    </div>;
};
const Menu = (menu: SidebarMenu) => {
  const router = useRouter();
  const isActive = isSidebarMenuActive(router.pathname, menu.href, menu.activeHrefs);
  const Icon = isActive && menu.activeIcon ? menu.activeIcon : menu.icon;
  return <DynamicTag {...menu} onClick={menu.onClick} key={menu.label} target={menu.target} className={cn('flex min-h-[45px] rounded-md cursor-pointer items-center gap-xs px-md py-sm text-body-lg-bold', isActive ? 'text-strong bg-opacity-violet-1' : 'text-alternative')} data-sentry-element="DynamicTag" data-sentry-component="Menu" data-sentry-source-file="SidebarMobileDropdownMenu.tsx">
      {<Icon size={'xs'} className={'shrink-0'} />}
      {menu.label}
    </DynamicTag>;
};
export type SidebarDropdownMenuProps = {
  menus: SidebarMenu[];
  footerMenus: SidebarMenu[];
  title: React.ReactNode;
  className?: string;
  hideMobileDropdown?: boolean;
};
const DynamicTag = ({
  href,
  children,
  className,
  target,
  onClick
}: SidebarMenu & {
  children: React.ReactNode;
  className: string;
}) => {
  if (href) {
    return <Link target={target ?? '_self'} href={href} className={className} onClick={onClick}>
        {children}
      </Link>;
  }
  return <div className={className} onClick={onClick} data-sentry-component="DynamicTag" data-sentry-source-file="SidebarMobileDropdownMenu.tsx">
      {children}
    </div>;
};